import { Outlet } from "react-router-dom"

export default function Lecturas({user, signOut}) {
    return <>
    <div className='App'>
      <Outlet></Outlet>
    </div>
    
  </>
}